import React from 'react';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import Card, { LigneCard } from '../../Card';
import LigneAdresse from '../../Adresse';


const CardPaiementCheque = ({
    Syn, Pro, Cop, setChoix,
}) => (
    <Card Titre="Paiement par chèque">
        <p>
            Libellez votre chèque à l&apos;ordre de : <strong>{Cop.Ind.Nom}</strong><br />
            Rappelez les références <strong>{Cop.Ind.Code} - {Pro.Ind.Code}</strong> au dos du chèque<br />
            Adressez le tout par courrier postal à :<br /><strong><LigneAdresse {...Syn.Ind.Adresse} /></strong>
        </p>
        <LigneCard valeur={
            <button onClick={() => { setChoix(0); }} className="btn btn-outline-danger w-25 mt-3">
                    Retour
            </button>}
        />
    </Card>
);
CardPaiementCheque.displayName = 'CardPaiementCheque';
CardPaiementCheque.titleName = 'Mon solde';
CardPaiementCheque.requiredProps = [
    'Syn', // info syndic
    'Pro', // info du propriétaire
    'Cop', // info de la copropriété
];

function mapStateToProps({
    SynStore: { Syn },
    ProStore: { Pro },
    CopStore: { Cop },
}) {
    return {
        Syn, Pro, Cop,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardPaiementCheque));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/CardPaiementCheque.js